import React, { useCallback } from 'react'
import { TreeItem } from '@mui/x-tree-view'
import { Checkbox, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import Text from '@/components/Text'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import { secondaryText, warning, defaultText } from '@/constant'

const Row = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}))
export interface TreeDataProps {
  name: string
  id: number | string
  children?: TreeDataProps[]
  hightlight?: boolean
}

const interStateChecker = (data: TreeDataProps, checked: Array<number | string>) => {
  // @ts-ignore
  for (const child of data?.children) {
    if (checked.indexOf(child?.id) === -1) {
      return false
    }
  }
  return true
}

const indeterminateCheck = (data: TreeDataProps, checked: Array<number | string>) => {
  let hasChecked = 0
  // @ts-ignore
  for (const child of data?.children) {
    if (checked.indexOf(child?.id) > -1) {
      hasChecked += 1
    }
  }
  // @ts-ignore
  if (hasChecked && hasChecked < data?.children?.length) {
    return true
  } else {
    return false
  }
}

const TreeNode = ({
  data,
  onNodeChange,
  checked,
  onItemClick,
}: {
  data: TreeDataProps
  onNodeChange: (checked: boolean, id: (number | string)[]) => void
  checked: Array<number | string>
  onItemClick?: (itemId: string) => void
}) => {
  const handleClickTreeItem = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation()
      // @ts-ignore
      if (data?.children) onItemClick(data?.id?.toString())
    },
    [data?.children, data?.id, onItemClick],
  )

  const stopCheckboxPropagation = useCallback((event: React.MouseEvent) => {
    event.stopPropagation()
  }, [])

  const handleNodeChange = useCallback(
    (event: React.ChangeEvent, checked: boolean) => {
      onNodeChange(checked, data?.children ? data?.children?.map((child) => child.id) : [data?.id])
    },
    [data?.children, data?.id, onNodeChange],
  )

  return (
    <TreeItem
      nodeId={data?.id?.toString()}
      onClick={handleClickTreeItem}
      expandIcon={
        <ArrowRightIcon onClick={handleClickTreeItem} sx={{ fontSize: '24px !important', color: secondaryText }} />
      }
      collapseIcon={
        <ArrowDropDownIcon onClick={handleClickTreeItem} sx={{ fontSize: '24px !important', color: secondaryText }} />
      }
      label={
        <Row>
          <Checkbox
            indeterminate={data?.children ? indeterminateCheck(data, checked) : false}
            checked={data?.children ? interStateChecker(data, checked) : checked.indexOf(data?.id) !== -1}
            onClick={stopCheckboxPropagation}
            onChange={handleNodeChange}
          />
          <Text
            onClick={handleClickTreeItem}
            weight={data?.hightlight ? 'bold' : 'regular'}
            sx={{ color: data?.hightlight ? warning : defaultText }}
          >
            {data?.name}
          </Text>
        </Row>
      }
    >
      {data?.children?.map((child, index) => (
        <TreeNode key={`sub-list-item-${index}`} data={child} checked={checked} onNodeChange={onNodeChange} />
      ))}
    </TreeItem>
  )
}

export default TreeNode
